import React from "react";
import { IconButton } from "@mui/material";
import styles from "./HomeIcon.module.css";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home"; // Importación correcta

const HomeIcono: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.headerIcon}>
    <IconButton disableRipple className={styles.iconHome} onClick={() => navigate("/")}>
      <HomeIcon  sx={{ fontSize: 40, color: "black", backgroundColor:"#fec93b", border:"black 2px solid", boxShadow:"5px 5px black",
         ":hover":{ backgroundColor:"transparent", border:"black 0px solid", boxShadow:"0px 0px black"} }} />
    </IconButton>
  </div>
 
  );
}
export default HomeIcono;